<script>
    import { onMount } from 'svelte';
    import { db } from './stores.js';
    import Screenshare from './Screenshare.svelte';
    import Camera from './Camera.svelte';
    import Chat from './Chat.svelte';

    export let id;
    let showPassword = false;
    let isAllowed = false;
    let status = "";
    let openTokCreds = {};
    let session;
    const role = 'guest';

    console.log('OT: ',OT);

    async function startSession(){
        const res = await fetch(`https://us-central1-otech-events.cloudfunctions.net/guest?id=${id}`)
        openTokCreds = await res.json();
        console.log('openTokCreds: ', openTokCreds);
        session = OT.initSession(openTokCreds.apiKey, openTokCreds.sessionId);
        console.log('session: ',session);
        session.connect(openTokCreds.token);
        session.on({
            streamCreated: function(event) {
                console.log('event.stream: ',event.stream);
                if (event.stream.videoType === 'camera'){
                    session.subscribe(event.stream, 'camera-container', { insertMode: 'append' });
                }
            }
        })
    };

    async function handleSubmit(e){
        status = "";
        console.log('password: ',e.target.password.value);
        $db.collection("broadcasts").doc(id).get()
        .then(function(doc) {
            if (doc.exists) {
                if (e.target.password.value === doc.data().password){
                    isAllowed = true;
                    startSession();
                } else {
                    status = "Invalid Password."
                }
            } else {
                status = "Error verifying password."
            }
        })

    }
</script>

<main>
    {#if isAllowed}
        <div id="guest-container">
            <div id="guest-controls">
                <div id="camera-container"></div>
                <Camera {id} {session} {role} />
                <Screenshare {id} {session} {role} />
            </div>
            <div id="chat">
                <Chat eventId = {id}/>
            </div>
        </div>
    {:else}
        <div id="container">
            <form id="set-password" on:submit|preventDefault={handleSubmit}>
                <label for="password">Enter Password from Host</label>
                <input type={showPassword ? "text" : "password"} id="password" required/>&nbsp; &nbsp;<span on:click={() => showPassword = !showPassword}>{showPassword ? "hide" : "show"}</span>
                <br/><button type="submit">submit</button>
            </form>
            <div id="status">{status}</div>
        </div>
    {/if}
</main>

<style>
    main {
        display: grid;
        place-items: center;
        height: 95vh;
    }
    #guest-container {
        display: grid;
        grid-template-columns: 1fr auto;
        width: 100%;
    }
    #guest-controls {
        display: grid;
        height: 90vh;
        place-items: center;
    }
    #chat {
        width: 30vw;
        height:70vh;
    }

</style>